import React, { useState } from "react";
import rwandaLogo from "../../assets/rwanda-logo.png";
import moment from "moment";
import LetterTemplateHeader from "../../documents/LetterTemplateHeader";
import LetterTemplateFooter from "../../documents/LetterTemplateFooter";

const AuthorizationByMinistry = (props) => {
  const {
    minstryLetterReferenceNo,
    draftAuthorizationSubjectByMinistry,
    draftAuthorizationContentByMinistry,
    headOfInstitution,
    signContent,
    isMifotraEntitySector,
    entitySectorId,
    loadFooterContent,
    planningEntityId
  } = props;
  const [letterCustomization, setLetterCustomization] = useState(null);

  const loadHeaderContent = (data) => {
    // console.log(data);
    setLetterCustomization(data);
  };

  return (
    <div className="letterMainContent">
      <div className="letter">
        {/* <div className="letterhead d-flex flex-column justify-content-center w-100">
          <div
            className="letterhead-title w-100"
            style={{ fontWeight: "bold", fontFamily: "Times New Roman" }}
          >
            REPUBLIC OF RWANDA
          </div>
          <div className="w-100">
            <img
              style={{ width: "100px", height: "100px" }}
              src={rwandaLogo}
              alt="Logo"
            />
          </div>
          <div
            className="letterhead-subtitle w-100"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              fontFamily: "Times New Roman",
            }}
          >
            {headOfInstitution.institutionName?.toUpperCase() || ''}
          </div>
        </div> */}
        <LetterTemplateHeader
          disableToEdit={true}
          entitySectorId={entitySectorId}
          planningEntityId={planningEntityId}
          loadHeaderContent={(data) => loadHeaderContent(data)}
        />
        <div className="subletterhead mt-3">
          <table>
            <tr>
              <td style={{ width: "70%" }}></td>
              <td style={{ width: "30%" }}>
                <p
                  className="date"
                  style={{
                    fontWeight: "bold",
                    float: "left",
                    textAlign: "left",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px`,
                  }}
                >
                  Kigali, on {moment(new Date()).format("MMMM Do, YYYY")}
                </p>
                <p
                  className="reference w-100"
                  style={{
                    fontWeight: "bold",
                    float: "left",
                    textAlign: "left",
                    position: "relative",
                    top: "-22px",
                    fontFamily:
                      letterCustomization?.styles?.fontFamily ||
                      "Times New Roman",
                    lineHeight: letterCustomization?.styles?.lineHeight,

                    lineSpacing: `${
                      letterCustomization?.styles?.lineSpacing || 0
                    }px`,
                  }}
                >
                  N<sup>o</sup>:{" "}
                  {minstryLetterReferenceNo
                    ? minstryLetterReferenceNo
                    : "........."}
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div className="recipient">
          {/* <!-- Recipient's name and address go here --> */}

          <p
            style={{
              fontSize: (letterCustomization?.styles?.fontSize || "12") + "px",
              fontFamily:
                letterCustomization?.styles?.fontFamily || "Times New Roman",
              lineHeight: letterCustomization?.styles?.lineHeight,

              lineSpacing: `${letterCustomization?.styles?.lineSpacing || 0}px`,
            }}
          >
            {isMifotraEntitySector ? (
              <>
                Chief Skills Officer <br />
                <strong>Rwanda Development Board</strong>
              </>
            ) : (
              <>Honorable Minister of Public Service and Labour</>
            )}

            <br />
            <span
              style={{
                position: "relative",
                top: "6px",
                fontWeight: "bold",
              }}
            >
              KIGALI
            </span>
          </p>
        </div>
        <div
          className="content2"
          style={{
            fontSize: (letterCustomization?.styles?.fontSize || "12") + "px",
            fontFamily:
              letterCustomization?.styles?.fontFamily || "Times New Roman",
            lineHeight: letterCustomization?.styles?.lineHeight,

            lineSpacing: `${letterCustomization?.styles?.lineSpacing || 0}px`,
          }}
        >
          {/* <!-- Letter content goes here --> */}
          {isMifotraEntitySector ? (
            <>
              <p>Dear Chief Skills Officer,</p>
            </>
          ) : (
            <>
              <p>Honorable Minister,</p>
            </>
          )}

          <p
            style={{
              fontWeight: "bold",
              fontSize: (letterCustomization?.styles?.fontSize || "12") + "px",
              fontFamily:
                letterCustomization?.styles?.fontFamily || "Times New Roman",
              lineHeight: letterCustomization?.styles?.lineHeight,

              lineSpacing: `${letterCustomization?.styles?.lineSpacing || 0}px`,
            }}
          >
          {draftAuthorizationSubjectByMinistry
              ? draftAuthorizationSubjectByMinistry
              : "Request the authorization to conduct a training"}
          </p>
          <div
            style={{
              fontSize:
                (letterCustomization?.styles?.fontSize || "12") +
                "px!important",
              fontFamily:
                letterCustomization?.styles?.fontFamily ||
                "Times New Roman!important",
              lineHeight: letterCustomization?.styles?.lineHeight,

              lineSpacing: `${
                letterCustomization?.styles?.lineSpacing || 0
              }px!important`,
            }}
            dangerouslySetInnerHTML={{
              __html: draftAuthorizationContentByMinistry
                ? draftAuthorizationContentByMinistry
                : "",
            }}
          ></div>
          {/* 0864297531 */}
        </div>
        <div className="signature2">
          <p
            style={{
              position: "relative",
              paddingBottom: "15px",
              fontWeight: 800,
              color: "red",
              fontSize:
                (letterCustomization?.styles?.fontSize || "12") +
                "px!important",
              fontFamily:
                letterCustomization?.styles?.fontFamily ||
                "Times New Roman!important",
              lineHeight: letterCustomization?.styles?.lineHeight,

              lineSpacing: `${
                letterCustomization?.styles?.lineSpacing || 0
              }px!important`,
            }}
          >
            {signContent ? (
              signContent
            ) : (
              <table>
                <tr>
                  <td
                    style={{
                      width: "20%",
                      fontSize: "12px",
                      textAlign: "left",
                      paddingLeft: "76px",
                    }}
                  >
                    <span
                      className="d-block text-danger"
                      style={{
                        fontSize:
                          (letterCustomization?.styles?.fontSize || "12") +
                          "px!important",
                        fontFamily:
                          letterCustomization?.styles?.fontFamily ||
                          "Times New Roman!important",
                        lineHeight: letterCustomization?.styles?.lineHeight,

                        lineSpacing: `${
                          letterCustomization?.styles?.lineSpacing || 0
                        }px!important`,
                      }}
                    >
                      Not signed
                    </span>
                  </td>
                  <td
                    style={{
                      width: "20%",
                      textAlign: "left",
                      fontSize:
                        (letterCustomization?.styles?.fontSize || "12") +
                        "px!important",
                      fontFamily:
                        letterCustomization?.styles?.fontFamily ||
                        "Times New Roman!important",
                      lineHeight: letterCustomization?.styles?.lineHeight,

                      lineSpacing: `${
                        letterCustomization?.styles?.lineSpacing || 0
                      }px!important`,
                    }}
                  ></td>
                </tr>
              </table>
            )}
          </p>
          <p
            className="mt-4"
            style={{
              fontSize:
                (letterCustomization?.styles?.fontSize || "12") +
                "px!important",
              fontFamily:
                letterCustomization?.styles?.fontFamily ||
                "Times New Roman!important",
              lineHeight: letterCustomization?.styles?.lineHeight,

              lineSpacing: `${
                letterCustomization?.styles?.lineSpacing || 0
              }px!important`,
              fontWeight: 800,
            }}
          >
            {headOfInstitution.title ? headOfInstitution.title + "." : ""}{" "}
            {headOfInstitution?.firstName || ""}{" "}
            {headOfInstitution?.lastName || ""}
          </p>
          <p
            style={{
              fontSize:
                (letterCustomization?.styles?.fontSize || "12") +
                "px!important",
              fontFamily:
                letterCustomization?.styles?.fontFamily ||
                "Times New Roman!important",
              lineHeight: letterCustomization?.styles?.lineHeight,

              lineSpacing: `${
                letterCustomization?.styles?.lineSpacing || 0
              }px!important`,
              fontWeight: 800,
            }}
          >
            {headOfInstitution.positionName}
          </p>
          {!!headOfInstitution?.canAddInstitutionName ? (
            <p
              style={{
                fontSize:
                  (letterCustomization?.styles?.fontSize || "12") +
                  "px!important",
                fontFamily:
                  letterCustomization?.styles?.fontFamily ||
                  "Times New Roman!important",
                lineHeight: letterCustomization?.styles?.lineHeight,

                lineSpacing: `${
                  letterCustomization?.styles?.lineSpacing || 0
                }px!important`,
                fontWeight: 800,
              }}
            >
              {headOfInstitution?.institutionName}
            </p>
          ) : (
            ""
          )}
        </div>
        <div className="mt-5 pt-5">
          <LetterTemplateFooter disableToEdit={true} />
        </div>
      </div>
    </div>
  );
};
export default AuthorizationByMinistry;
